import type * as SchemaTypes from '../types';

import { gql } from '@apollo/client';
export type UserPreviewDataFragment = (
  { __typename: 'User' }
  & Pick<SchemaTypes.User, 'id' | 'displayName' | 'email'>
);

export const UserPreviewDataFragmentDoc = /*#__PURE__*/ gql`
    fragment UserPreviewData on User {
  id
  displayName
  email
}
    `;